const STORE_PREFIX = 'WindowEvent_';

export const Actions = {
	SET_SCROLL: STORE_PREFIX+'SET_SCROLL',
	SET_SIZE: STORE_PREFIX+'SET_SIZE',
	SET_LOAD: STORE_PREFIX+'SET_LOAD'
}

export function setScroll(scrollY,scrollX)
{
	return{
		type: Actions.SET_SCROLL,
		payload: {y:scrollY,x:scrollX}
	}
}
export function setSize(width,height)
{
	return{
		type: Actions.SET_SIZE,
		payload: {width:width,height:height}
	}
}
export function setLoaded(isLoaded)
{
	return{
		type: Actions.SET_LOAD,
		payload: isLoaded
	}
}
